<p-table [columns]="cols" [value]="displayedRows" [responsive]="true" [autoLayout]="true">
  <ng-template pTemplate="header" let-columns>
    <tr class="no-wrap-headers">
      <th *ngFor="let col of columns">{{col.header}}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row let-columns="columns">
    <tr *ngIf="!loading; else loadingRow" [class.auto-table-row-clickable]="enableRowClick" (click)="enableRowClick ? onRowClicked.emit(row) : null">
      <td *ngFor="let col of columns">
        <span class="p-column-title">{{col.header}}</span>

        <!-- default cell -->
        <ng-container *ngIf="!col.type">
          {{row[col.field]}}
        </ng-container>

        <!-- dates -->
        <ng-container *ngIf="col.type === 'date'">
          <span *ngIf="col.dateFormat">{{ row[col.field] | date: col.dateFormat }}</span>
          <date-friendly *ngIf="!col.dateFormat" [value]="row[col.field]"></date-friendly>
        </ng-container>

        <!-- username -->
        <ng-container *ngIf="col.type === 'username'">
          <username-display
            [userName]="row[col.field]"
            [displayName]="col.displayField ? row[col.displayField] : null">
          </username-display>
        </ng-container>

        <!-- free text that can run long, e.g. a rejection comment: clamped so one verbose
             entry cannot blow out the row height, with the full text in the tooltip -->
        <ng-container *ngIf="col.type === 'truncated_text'">
          <span class="auto-table-truncated" [ngbTooltip]="row[col.field]" [disableTooltip]="!row[col.field]">
            {{ row[col.field] }}
          </span>
        </ng-container>

        <!-- link to work order -->
        <ng-container *ngIf="col.type === 'link' && !row.hideLink">
          <button type="button" (click)="onLinkClicked.emit(row); $event.stopPropagation()" class="btn btn-primary btn-link">{{ col.linkText }}</button>
        </ng-container>

        <!-- action button -->
        <ng-container *ngIf="col.type === 'action_view' && !row.hideLink">
          <button
            type="button"
            class="btn btn-primary btn-link procedure-view-button"
            (click)="onLinkClicked.emit(row); $event.stopPropagation()">
            <i class="fa fa-search"></i>
            View
          </button>
        </ng-container>

        <!-- tick or information text, for invite users results -->
        <ng-container *ngIf="col.type === 'tick-or-text'">
          <ng-container *ngIf="row[col.field] === true">
            <i class="fas fa-check-circle success"></i>
          </ng-container>
          <ng-container *ngIf="row[col.field] !== true">
            <span class="text-success">{{row[col.field]}}</span>
          </ng-container>
        </ng-container>

        <!-- status badge -->
        <ng-container *ngIf="col.type === 'workflow_status'">
          <span *ngIf="row[col.field] === 'APPROVED'" class="badge badge-pill badge-success">Approved</span>
          <span *ngIf="row[col.field] === 'REJECTED' || row[col.field] === 'DOCUMENT_REJECTED'" class="badge badge-pill badge-danger">Rejected</span>
        </ng-container>

        <!-- status badge -->
        <ng-container *ngIf="col.type === 'work_order_status'">
          <work-order-state-badge [workOrder]="row"></work-order-state-badge>
        </ng-container>

        <!-- status badge -->
        <ng-container *ngIf="col.type === 'training_course_status'">
          <span *ngIf="row[col.field] === 'COMPLETED'" class="badge badge-pill badge-success">Completed</span>
          <span *ngIf="row[col.field] === 'IN_PROGRESS'" class="badge badge-pill badge-danger">In Progress</span>
          <span *ngIf="row[col.field] === 'NOT_STARTED'" class="badge badge-pill badge-danger">Not Started</span>
          <span *ngIf="row[col.field] === 'EXPIRED'" class="badge badge-pill badge-danger">Expired</span>
        </ng-container>
      </td>
    </tr>
    <ng-template #loadingRow>
      <tr>
        <td [attr.colspan]="columns.length">
          <skeleton-loading-row></skeleton-loading-row>
        </td>
      </tr>
    </ng-template>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length">{{ emptyMessage }}</td>
    </tr>
  </ng-template>
</p-table>
